

import { Options, Vue } from "vue-class-component";
// import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'

@Options({
  components: {},
})
export default class DestroyAccount extends Vue {
  mounted() {
    
  }
  confirmDestroy() {
    // @ts-ignore
    this.$router.push({
      name: 'DestroyAccountReason'
    })
  }
}
